import { Component, computed, input } from '@angular/core';

@Component({
    selector: 'warema-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    host: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        '[class.spin-faster]': 'spinFaster()',
        // eslint-disable-next-line @typescript-eslint/naming-convention
        '[class.thin-line]': 'thinLine()',
        // eslint-disable-next-line @typescript-eslint/naming-convention
        '[style.width]': 'diameterPixel()',
        // eslint-disable-next-line @typescript-eslint/naming-convention
        '[style.height]': 'diameterPixel()',
    },
})
export class SpinnerComponent {
    public readonly diameter = input(50);

    public readonly spinFaster = input(false);
    public readonly thinLine = input(false);

    public readonly diameterPixel = computed(() => `${this.diameter()}px`);
    public readonly borderRadius = computed(() => `${this.diameter() * 2}px`);
}
